import {useMemo} from "react";
import {useSearchParams} from "react-router-dom";

import {PRODUCTS} from "data/products";
import {ALL_PRODUCT, DEFAULT_PRODUCT, DEFAULT_PRODUCTS_MAPPING} from "data/constants";
import {useRouteParams, DEFAULT_ROUTE_PATTERNS} from "hooks/useRouteParams";

export function useProductFromParams() {
  const params = useRouteParams(DEFAULT_ROUTE_PATTERNS);
  const [searchParams] = useSearchParams();
  const selectedSet = searchParams.get("set");

  return useMemo(() => {
    const productParam = params?.product ?? null;
    const channelParam = params?.channel ?? null;

    if (productParam === ALL_PRODUCT.value) {
      const isAllProductsWhatsNew = channelParam === "releases" && selectedSet === "whats-new";
      if (isAllProductsWhatsNew) {
        return ALL_PRODUCT;
      }

      const defaultProductCode = DEFAULT_PRODUCTS_MAPPING[channelParam] || DEFAULT_PRODUCT.value;
      return PRODUCTS.find((p) => p.value === defaultProductCode) ?? DEFAULT_PRODUCT;
    }

    return PRODUCTS.find((p) => p.value === productParam) ?? DEFAULT_PRODUCT;
  }, [params, selectedSet]);
}
